module.exports = __webpack_public_path__ + "static/useful_data_icon-af33f98cad3187316284d40a3e88bbb7.svg";